<app-header></app-header>


<div class="loader-container" *ngIf="loadingSequence">
  <div class="three-strings">
    <span></span>
    <span></span>
    <span></span>
  </div>
  <div class="processing-text">Processing...</div>
</div>


<section>
  <div class="container">
    <div class="row">
      <div class="text-center" >
        <div class="forgotdiv">
          <mat-stepper #stepper>
            <mat-step [stepControl]="firstFormGroup">
              <form [formGroup]="firstFormGroup">
                <ng-template matStepLabel class="bold">Registration as  MSME</ng-template>
                <div class="row">
                  <div class="col-lg-12 text-start">
                    <div class="mdc-text-field">
                      <mat-label>UDYAM Registration number <span class="text-danger">*</span></mat-label>
                      <input id="txtudyamRegistrationNumber" type="text" matInput autocomplete="off" placeholder="UDYAM-MH-XX-XXXXXXX"
                             class="form-control mdc-text-field-input" formControlName="udyamRegistrationNumber" required maxlength="19" >                      
                      <div *ngIf="f['udyamRegistrationNumber'].touched && f['udyamRegistrationNumber'].invalid" class="alert alert-danger required">
                        <div *ngIf="f['udyamRegistrationNumber'].errors && f['udyamRegistrationNumber'].errors['required']">
                          Udyam number is required
                        </div>                        
                        <div *ngIf="f['udyamRegistrationNumber'].errors && f['udyamRegistrationNumber'].errors['pattern']">
                          <!--Your UDYAM registration number is invalid.-->
                          Please enter a valid UDYAM registration number.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 text-start">
                    <div class="mdc-text-field">
                      <mat-label>Mobile Number <span class="text-danger">*</span></mat-label>
                      <input id="txtownersMobileNumber" type="text" matInput placeholder="Enter Mobile Number"
                             class="form-control" formControlName="ownersMobileNumber" required maxlength="10" minlength="10">
                      <div *ngIf="f['ownersMobileNumber'].touched && f['ownersMobileNumber'].invalid" class="alert alert-danger required">
                        <div *ngIf="f['ownersMobileNumber'].errors && f['ownersMobileNumber'].errors['required']">
                          Mobile number is required
                        </div>                        
                        <div *ngIf="f['ownersMobileNumber'].errors && f['ownersMobileNumber'].errors['pattern']">
                          Mobile number should be 10 digits only, first digit should be non zero
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="alert alert-warning">Please enter Mobile Number Registered with your Udyam Registration.OTP will be sent to it.</div>
                  </div>
                </div>
                <div>
                  <button matStepperNext (click)="verifyUser()" class="btn btn-success">Verify User</button>
                  <button (click)="goToLogin()" class="btn btn-danger">Cancel</button>
                </div>
                <div class="alert">
                  <p>Don't have UDYAM Registration? <br /><a href="https://udyamregistration.gov.in/Government-India/Ministry-MSME-registration.htm">Click here for UDYAM Registration</a></p>
                </div>
              </form>
            </mat-step>
          </mat-stepper>
        </div>
      </div>
    </div>
  </div>
</section>
<app-footer></app-footer>
